import React, { useEffect, useState } from "react";

export default function SolutionsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const solutions = [
    {
      id: 1,
      title: "Produto Solidário",
      description: "Transforme qualquer produto, serviço ou experiência em impacto positivo. Pode ser desde a criação de um item ou lojinha exclusiva até a destinação de um percentual de vendas para doação.",
      additionalText: "Toda a arrecadação é processada pela Karma Wallet com rastreabilidade do uso e doações. A empresa ganha:",
      benefits: [
        "• Engajamento com clientes e colaboradores;",
        "• Fortalecimento da imagem ESG;",
        "• Métricas claras de impacto para comunicar resultados."
      ],
      bgColor: "bg-[#C684F5]",
      image: "/assets/landing-2025/food-plate.png",
    },
    {
      id: 2,
      title: "Experiências de Impacto",
      description: "Ativações corporativas presenciais ou híbridas com propósito desde de datas de conscientização ou celebrativas até experiências personalizadas com alto engajamento e visibilidade. Temos como diferencial a gamificação das ações, ajudando a aumentar o engajamento dos participantes e atingir resultados com ainda mais impacto.",
      benefits: [
        "• Ativações de marca",
        "• Voluntariado Corporativo"
      ],
      bgColor: "bg-[#002342]",
      image: "/assets/landing-2025/man-with-trash-bag.jpg",
    },
    {
      id: 3,
      title: "Hub de ONGs & Projetos Incentivados",
      description: "Portfólio validado de projetos em Leis de Incentivo (Rouanet, Esporte, ICMS etc.) com ONGs parceiras prontas para execução e storytelling com propósito.",
      benefits: [
        "• Curadoria de ONGs qualificadas com relatórios de transparência.",
        "• Projetos aprovados ou em captação.",
        "• Suporte na inscrição, documentação e conexão com patrocinadores."
      ],
      bgColor: "bg-[#C684F5]",
      image: "/assets/landing-2025/favela.png",
    },
    {
      id: 4,
      title: "Plataforma karma wallet (APP)",
      description: `Uma infraestrutura digital de doação gamificada: os usuários acompanham seu impacto, escolhem suas causas e recebem recompensas simbólicas exclusivas em um ecossistema de "karma kredits".`,
      benefits: [
        "• Marketplace solidário onde cada doação destrava recompensas em produtos ou experiências com marcas parceiras.",
        "• API para integração B2B.",
        "• Interface otimizada para rastreamento de impacto e engajamento social."
      ],
      bgColor: "bg-[#002342]",
      image: "/assets/landing-2025/social-tech-de-impacto.png",
      contain: true,
    }
  ];

  const [currentSolution, setCurrentSolution] = useState(solutions[0]);


  const nextSlide = () => {
    const lastIndex = solutions.length - 1;
    const nextSlide = currentSlide + 1;

    if(nextSlide <= lastIndex) {
      setCurrentSlide(nextSlide);
    }
  };

  const prevSlide = () => {
    const prevSlide = currentSlide - 1;

    if(prevSlide >= 0) {
      setCurrentSlide(prevSlide);
    }
  };

  useEffect(() => {
    setCurrentSolution(solutions[currentSlide]);
  }, [currentSlide])

  return (
    <section id="solucoes" className="px-4 md:px-10 xl:pl-[199px] xl:pr-[82px] py-12 md:py-16">
      {/* Main Grid Layout: Title/Navigation Left, Cards Right */}
      <div className="grid grid-cols-1 xl:grid-cols-[400px_1fr] gap-8 md:gap-12 lg:gap-16 items-center">

        {/* Left Column: Title and Navigation */}
        <div className="flex flex-col">
          <h2 className="font-bauhaus font-bold text-center xl:text-left text-xl sm:text-2xl md:text-3xl lg:text-[36px] xl:text-[42px] leading-tight md:leading-[46px] text-[#002342] mb-6 md:mb-8 lg:mb-12">
            Soluções para marcas e empresas, como a sua
          </h2>

          {/* Carousel Navigation */}
          <div className="flex items-center gap-4 md:gap-6 xl:justify-start justify-center">
            {/* Previous Button */}
            <button
              onClick={prevSlide}
              disabled={currentSlide === 0}
              className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center transition-colors group ${currentSlide === 0 ? 'bg-gray-300 hover:none' : 'bg-[#85C4FF] hover:bg-[#002342]'}`}
              aria-label="Soluções anteriores"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {/* Slide Indicators */}
            <div className="flex gap-2">
              {solutions.map((_, slideIndex) => (
                <button
                  key={slideIndex}
                  onClick={() => setCurrentSlide(slideIndex)}
                  className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-colors ${
                    currentSlide === slideIndex ? 'bg-[#002342]' : 'bg-[#85C4FF]'
                  }`}
                  aria-label={`Ir para slide ${slideIndex + 1}`}
                />
              ))}
            </div>

            {/* Next Button */}
            <button
              onClick={nextSlide}
              disabled={currentSlide === solutions.length - 1}
              className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center transition-colors group ${currentSlide === solutions.length - 1 ? 'bg-gray-300 hover:none' : 'bg-[#85C4FF] hover:bg-[#002342]'}`}
              aria-label="Próximas soluções"
            >
              <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        {/* Right Column: Solution Cards */}
        <div className={`flex ${currentSolution.bgColor} rounded-[20px] sm:rounded-[25px] md:rounded-[30px] lg:rounded-[40px] xl:rounded-[60px] text-white lg:min-h[500px] lg:h-[500px]`}>
          <div key={currentSolution.id} className="flex flex-col p-6 lg:pl-16 justify-center">
            <h3 className="font-bauhaus font-bold text-[14px] sm:text-[15px] md:text-[16px] lg:text-[17px] xl:text-[18px] leading-[18px] sm:leading-[19px] md:leading-[20px] mb-3 sm:mb-4">
              {currentSolution.title}
            </h3>
            <p className="font-bauhaus text-[12px] sm:text-[13px] md:text-[14px] lg:text-[15px] xl:text-[16px] font-normal leading-[16px] sm:leading-[17px] md:leading-[18px] lg:leading-[19px] xl:leading-[20px] mb-3 sm:mb-4 md:mb-[24px]">
              {currentSolution.description}
            </p>
            {currentSolution.additionalText && (
              <p className="font-nunito text-[12px] sm:text-[13px] md:text-[14px] lg:text-[15px] xl:text-[16px] font-normal leading-[16px] sm:leading-[17px] md:leading-[18px] lg:leading-[19px] xl:leading-[20px] mb-3 sm:mb-4 md:mb-[24px]">
                {currentSolution.additionalText}
              </p>
            )}
            {currentSolution.benefits && (
              <div>
                  <ul className="space-y-[4px] font-raleway text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14px] xl:text-[15px] font-medium">
                    {currentSolution.benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
              </div>
            )}
          </div>
          <div class="hidden lg:flex items-center w-[300px] 2xl:w-[379px] min-w-[300px] 2xl:min-w-[379px] max-w-[300px] 2xl:max-w-[379px]">
            <img
              src={currentSolution.image}
              alt="Imagem"
              class={`w-full ${ currentSolution.contain ? 'h-[60%] object-center' : 'h-full'} object-cover lg:rounded-r-[40px] xl:rounded-r-[60px]`}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
